import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Image } from 'src/app/components/Image/Image';
import { withStyles } from 'src/app/helpers/styles';
import ImagePlayHover from 'src/images/play-hover.svg';

interface MyProps {
  className?: string;
  isLarge?: boolean;
}

@withStyles(require('./Play.scss'))
export class Play extends React.Component<MyProps> {
  shouldComponentUpdate(): boolean {
    return false;
  }

  render(): JSX.Element {
    const { className, isLarge } = this.props;
    return (
      <div className={classnames('position-absolute play', { 'play--large': isLarge }, className)}>
        <FormattedMessage id="button.play.video">
          {(message: string) => <Image alt={message} className="w-100" lazyLoad={false} src={ImagePlayHover} />}
        </FormattedMessage>
      </div>
    );
  }
}
